import type { BigNumber } from "bignumber.js";
import cn from "classnames";
import type { FC, MouseEvent } from "react";
import { t } from "ttag";

import { TokenImage } from "@/components/common/token";
import { formatCoin } from "@/util/format-coin";

import {
  TradePendingBody,
  TradePendingWrapper,
  WithdrawAll,
} from "../trade.styled";

function stopPropagation(e: MouseEvent) {
  e.stopPropagation();
}

const WithdrawAllPartial: FC<{
  amount?: BigNumber;
  containerClassName?: string;
  token?: string;
  close?: () => void;
  submit?: () => void;
}> = ({ amount, close, containerClassName, submit, token }) => {
  return (
    <TradePendingWrapper className="withdraw-all" onClick={close}>
      <TradePendingBody
        onClick={stopPropagation}
        className={cn(containerClassName, "withdraw-all")}
      >
        <WithdrawAll.Icon>
          {token && <TokenImage token={token} />}
        </WithdrawAll.Icon>
        <WithdrawAll.Title>{t`Withdraw all ${token}?`}</WithdrawAll.Title>

        <WithdrawAll.Description>
          {t`You will no longer earn interest on the loan.`}
        </WithdrawAll.Description>

        <WithdrawAll.ActionButton onClick={submit}>
          {t`Withdraw`} {formatCoin(amount)} {token}
        </WithdrawAll.ActionButton>
        <WithdrawAll.CancelButton onClick={close}>
          {t`Cancel`}
        </WithdrawAll.CancelButton>
      </TradePendingBody>
      {/*}
      <WithdrawAll.Container
        className={containerClassName}
      ></WithdrawAll.Container>
        */}
    </TradePendingWrapper>
  );
};

export default WithdrawAllPartial;
